import { h4, palette } from '@/modules/defines/styles';
import styled from 'styled-components';

import Lottie from 'react-lottie';
import loading from '@/assets/lottie/loading.json';
interface LoadingProps {
  isLoading: boolean;
  text: string;
}
const LoadingModal = ({ isLoading, text }: LoadingProps) => {
  if (!isLoading) return null; // 로딩 상태가 아닐 때 렌더링 안 함
  return (
    <ModalBackground $isLoading={isLoading}>
      <ModalContainer $isLoading={isLoading}>
        <Lottie
          width={'2rem'}
          height={'2rem'}
          options={{
            loop: true,
            autoplay: true,
            animationData: loading,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid slice',
            },
          }}
        />
        <Title>{text}</Title>
      </ModalContainer>
    </ModalBackground>
  );
};

const ModalBackground = styled.div<{ $isLoading: boolean }>`
  display: ${(props) => (props.$isLoading ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${palette.bgOverlay1};
  z-index: 100;
`;

const ModalContainer = styled.div<{ $isLoading: boolean }>`
  display: ${(props) => (props.$isLoading ? 'flex' : 'none')};
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;

  width: 20rem;
  height: 8.75rem;

  border-radius: 0.75rem;
  background: ${palette.secondaryRed700};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 8px 18px -6px rgba(0, 0, 0, 0.12),
    0px 12px 42px -2px rgba(0, 0, 0, 0.12);
`;

const Title = styled.h2`
  color: white;
  ${h4};
`;
export default LoadingModal;
